import { useNavigationAutoObuPairs } from 'entities/navigation';
import { UserDevice } from '../types/userDevice';
import { useGetListUnactiveDevices } from './useGetListUnactiveDevices';

export const useGridT4EboxDevices = (): UserDevice[] => {
  const unactiveDevices = useGetListUnactiveDevices();
  const obuDevices = useNavigationAutoObuPairs();

  const obuDevicesGridData = (obuDevices ?? []).map(({ autoNumber, obuNumber }) => ({
    card: '',
    deviceSn: obuNumber,
    deviceType: 'E-Box',
    status: 'Active',
    truckNumber: autoNumber,
  }));

  const unactiveDevicesGridData = unactiveDevices.map(({ autoNumber, clientObuId, secureEboxCardNumber }) => ({
    card: secureEboxCardNumber,
    deviceSn: clientObuId,
    deviceType: 'E-Box',
    status: 'Unactive',
    truckNumber: autoNumber,
  }));

  return [...obuDevicesGridData, ...unactiveDevicesGridData];
};
